@if (clientLayout) {
  <div class="object-form">
    <mrd-form
      #mrdFormEl
      [layout]="clientLayout"
      [showCancel]="true"
      (mrdSubmit)="onMrdSubmit($any($event))"
      (mrdCancel)="onCancel()"
      (mrdUpload)="onMrdUpload($any($event))">
    </mrd-form>
  </div>
}
